var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_648_5827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99943 19.2104L13.6839 7.87695H6.32031L9.99943 19.2104Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1594 7.87695L0.037381 11.3202C-0.0641521 11.6328 0.0454967 11.978 0.313487 12.1729L9.99935 19.2103L1.1594 7.87695Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15918 7.87703H6.31995L4.0989 1.05145C3.98523 0.702251 3.48982 0.702251 3.37206 1.05145L1.15918 7.87703Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8448 7.87695L19.9628 11.3202C20.0643 11.6328 19.9547 11.978 19.6867 12.1729L9.99951 19.2103L18.8448 7.87695Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8444 7.87703H13.6836L15.9006 1.05145C16.0143 0.702251 16.5097 0.702251 16.6274 1.05145L18.8444 7.87703Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 19.2103L13.684 7.87695H18.8448L9.99951 19.2103Z",
    fill: "#FC6D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99907 19.2103L1.15918 7.87695H6.31995L9.99907 19.2103Z",
    fill: "#FC6D26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_5827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/Gitlab.b96b0008d071652a0c29bc2b671a7de6.svg";
export { ForwardRef as ReactComponent };